import { Close, LogoutIcon, RightArrowIcon } from 'assets/Icons';
import useLogout from 'hooks/logout';
import { BUSINESS_NAVS, NAVIGATION_LINKS } from 'navigation/AccountRoutes/navs';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { userRoleAtom } from 'store/atoms/userAtom';
import { COMMONTYPES } from 'TYPES/event.types';
import { LogoutCon, RouteLink } from './styles';

type MobileAccountProps = {
  onNavigate: () => void;
};

const MobileAccount = ({ onNavigate }: MobileAccountProps) => {
  const navigate = useNavigate();
  const userRole = useRecoilValue(userRoleAtom);
  const logout = useLogout();
  const [showCategories, setShowCategories] = useState(false);

  const _logout = async (e: COMMONTYPES['divClick']) => {
    e.preventDefault();
    logout();
  };

  // Helper to identify the Categories item
  const isCategories = (label: string) => label.toLowerCase() === 'categories';

  const navs = userRole === 'BUSINESS' ? BUSINESS_NAVS : NAVIGATION_LINKS;

  return (
    <div style={{ position: 'relative', paddingTop: 48 }}>
      {/* Close icon at the top right */}
      <button
        style={{
          position: 'absolute',
          top: 12,
          right: 12,
          background: 'none',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          zIndex: 1
        }}
        aria-label="Close"
        onClick={() => navigate(-1)}>
        <Close style={{ width: 16, height: 16, color: '#222' }} />
      </button>
      {navs.map(({ to, label, Icon }) => {
        return (
          <RouteLink key={to} to={`/account/${to}` || '/'} onClick={onNavigate}>
            <span>
              {Icon && <Icon />}
              {label}
            </span>{' '}
            <RightArrowIcon />
          </RouteLink>
        );
      })}
      <LogoutCon onClick={_logout}>
        <LogoutIcon />
        Logout
      </LogoutCon>
    </div>
  );
};

export default MobileAccount;
